import {connect} from 'react-redux';
import React, {Component} from 'react';
import Layout from "./Base/Layout";

class NotFoundPage extends Component {
    render() {
        let {i18n} = this.props;


        return (
            <Layout
                showPromoContent={false}
                title={"404"}
            >
                <div className="clearfix container">
                    <div className="clearfix white_box add_container conv-blc">
                        <img src="/static/imgs/404-permalink.png" />
                    </div>
                </div>
            </Layout>
        );
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundPage);



// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js